import { Component } from '@angular/core';

@Component({
    selector: 'ifb-root',
    templateUrl: './app.component.html',
    standalone: false
})
export class AppComponent {
 
  title = 'backoffice';
}
